export default __webpack_public_path__ + "static/media/home.b4db2366.png";